import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./NewNav";

const WebsiteLayout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default WebsiteLayout;